import { useAppSelector } from 'flex/utils';
import ControlSetting from './ControlSettings';
import AdminSetting from './AdminSettings';

type Props = {
    tabActiveKey: string;
    hasTouchScreen: boolean;
};

export const UserSetting: React.FC<Props> = ({ hasTouchScreen, tabActiveKey }) => {
    const isControllableUser = useAppSelector((state) => state.isControllableUser.payload);

    return isControllableUser ? (
        <ControlSetting hasTouchScreen={hasTouchScreen} tabActiveKey={tabActiveKey} />
    ) : (
        <AdminSetting hasTouchScreen={hasTouchScreen} tabActiveKey={tabActiveKey} />
    );
};
